<div class="card card-statistics mb-30">
  <div class="card-body" [hidden]="Selected_LetterRequestCustomer_Device.id>0">
      <h5 class="card-title">
         فرم تکمیل مشخصات دستگاه مربوط به نامه شماره '{{Letter_Id}}'
          ({{DeviceFormList.length}} دستگاه در این نامه ثبت شده است)
        </h5>


      <br/>
      <br/>


      <div class="table-responsive" >
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        <p *ngIf="Procssing">لطفا صبر نمائید ...</p>

        <table *ngIf="!Procssing"  class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>دستگاه لاتین</th>
              <th>دستگاه فارسی</th>
              <th>محل کالیبراسیون</th>
              <th>ملاحظه</th>

              <th>کاربر</th>
              <th>تاریخ</th>
              <th>
                امکانات
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceFormList | paginate
            : {
                id: 'DeviceFormList',
                itemsPerPage: 10,
                currentPage: page,
                totalItems: (DeviceFormList).length
              }">
              <td>{{DeviceFormList.indexOf(item)+1}}</td>

              <td class="EnglishClm">{{item.device_name_en}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.location_name}}</td>
              <td>{{item.price_dsc}}</td>


              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <button type="button" *ngIf="item.calibration_detail_id==-1 && !ProcssingOperation" (click)="SetRecord(item)" class="btn btn-danger left"> ثبت اطلاعات دستگاه  </button>
                <img *ngIf="ProcssingOperation" src="assets/Loading.gif" style="width: 25px;" />
              </td>

            </tr>

          </tbody>
        </table>
      </div>
      <pagination-controls
      id="DeviceFormList"
      nextLabel="بعدی"
      previousLabel="قبلی"
      (pageChange)="page = $event"
    ></pagination-controls>
      <br/>
      <br/>
      <button routerLink="/LetterRequestCustomerDeviceList"  type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>


  </div>


  <div class="card-body" *ngIf="Selected_LetterRequestCustomer_Device.id>0">
    <h5 class="card-title">
      فرم تکمیل مشخصات دستگاه مربوط به نامه شماره '{{Letter_Id}}'
       ({{DeviceFormList.length}} دستگاه در این نامه ثبت شده است)
     </h5>
    <form  >

      <div class="row">
        <div class="form-group col-md-2">
          <label for="exampleInputEmail1">ردیف</label>
          <label  class="form-control">{{Selected_LetterRequestCustomer_Device_Int}}</label>
        </div>
        <div class="form-group col-md-5">
          <label for="exampleInputEmail1">دستگاه لاتین</label>
          <label  class="form-control">{{Selected_LetterRequestCustomer_Device.device_name_en}}</label>
        </div>
        <div class="form-group col-md-5">
          <label for="exampleInputEmail1">دستگاه فارسی</label>
          <label  class="form-control">{{Selected_LetterRequestCustomer_Device.device_name}}</label>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-2">
          <label for="exampleInputEmail1">محل کالیبراسیون</label>
          <label  class="form-control">{{Selected_LetterRequestCustomer_Device.location_name}}</label>
        </div>
        <div class="form-group col-md-10">
          <label for="exampleInputEmail1">ملاحظه</label>
          <label  class="form-control">{{Selected_LetterRequestCustomer_Device.price_dsc}}</label>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">سریال دستگاه</label>
          <input [(ngModel)]="Selected_LetterRequestCustomer_Device.deviceSerial" name="deviceSerial" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">کد دستگاه</label>
          <input [(ngModel)]="Selected_LetterRequestCustomer_Device.deviceCode" name="deviceCode" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نقطه یا گستره‌ی مورد نیاز</label>
          <input [(ngModel)]="Selected_LetterRequestCustomer_Device.gostareh" name="gostareh" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">توضیحات</label>
          <input [(ngModel)]="Selected_LetterRequestCustomer_Device.deviceCustomerDsc" name="deviceCustomerDsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

      <img *ngIf="ProcssingOperation" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!ProcssingOperation" (click)="SubmitDevice()" type="button" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button (click)="OnBack()" *ngIf="!ProcssingOperation" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>


</div>


